import { createAction } from '@ngrx/store';

export const openMobileMenu = createAction('[Client] Open Mobile Menu');

export const closeMobileMenu = createAction('[Client] Close Mobile Menu');
